




































import Vue from 'vue';
import Component from 'vue-class-component';
import { Watch } from 'vue-property-decorator';
import { Prop } from 'vue-property-decorator';
import { DxButton, DxPopup, DxLookup, DxSelectBox } from 'devextreme-vue';
import DxToolbar from 'devextreme-vue/toolbar';
import { LoadOptions } from 'devextreme/data/load_options';
import { FeeSheetTemplateService } from '../../service/FeeSheetTemplateService';
import { DxToolbarItem } from 'devextreme-vue/popup';
import { Popup } from '@questelservices/common-vue';
import { FeeSheetTemplateDto } from '../../models/FeeSheetTemplates/FeeSheetTemplateDto';


@Component({
  components: {
    DxButton,
    DxLookup,
    DxSelectBox,
    DxToolbar,
    DxToolbarItem,
    Popup
  }
})
export default class CreateFeeSheetFromTemplate extends Vue {
    $refs: Vue['$refs'] & {   
    } = {};

    @Prop({ default: false })
    showDialog!: boolean;

    get showingDialog() {
        return this.showDialog;
    }

    set showingDialog(value:boolean) {
        this.hidingModal();
    }

    @Watch("showDialog")
    async onShowPropChange(value: boolean, oldValue: boolean) {
        if(value){
            this.selectedTemplate = null;
            this.createClientSheet = false;
        }
    }


    dialogTitle: string = "Which Template Would You Like To Use?";
    feeSheetTemplates: FeeSheetTemplateDto[] = [];
    selectedTemplate: any = null; 
    createClientSheet: boolean = false;   

    constructor() {
        super();        
        this.loadData();
    }

    async loadData() {
        let feeSheetTemplateService = new FeeSheetTemplateService('/api/FeeSheetTemplate');
        feeSheetTemplateService.getAll()
        .then(result => {
            this.feeSheetTemplates = result;
            let useNoTemplate: FeeSheetTemplateDto = {
                TemplateName: "Create New Fee Sheet",
                FeeSheetTemplateId: "",
                Notes: "",
                FeeSheetTemplatePhases: [],
                FeeSheetTemplateTasks: [],
                InJurisdiction: false
            }
            this.feeSheetTemplates.unshift(useNoTemplate);
        });
    }

    save(): void {
        this.$emit("hidingCreateFromTemplate", this.selectedTemplate);
        this.createClientSheet = true;
    }

    hidingModal(): void {
        this.$emit("hidingCreateFromTemplate");
    }

    onPopupHidden(): void {
        this.$emit("onCreateFromTemplateHidden", this.createClientSheet);
    }
}
